import { render, staticRenderFns } from "./CommodityMarketingTitle.vue?vue&type=template&id=15bc58bf&scoped=true&"
import script from "./CommodityMarketingTitle.vue?vue&type=script&lang=js&"
export * from "./CommodityMarketingTitle.vue?vue&type=script&lang=js&"
import style0 from "./CommodityMarketingTitle.vue?vue&type=style&index=0&id=15bc58bf&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15bc58bf",
  null
  
)

export default component.exports